import type { UserRole } from "@/lib/auth";

// Navbar personalisation state, shared by /api/nav-state and the
// NavbarIsland client component. The root layout is static; this state is
// fetched after hydration for logged-in users only.

export type NavState = {
  role: UserRole;
  unreadCount: number;
  shortlistCount: number;
  candidateName?: string;
  candidatePhotoUrl?: string;
  profileId?: string;
  employerCompanyName?: string;
  employerCompanyLogo?: string;
  employerCompanySlug?: string;
  crewAnyUnread: boolean;
  crewAnyMention: boolean;
  hasEpicSpot: boolean;
  /** Unread Calls in the in-app inbox (/companion/calls). */
  callsUnread: boolean;
  /** Whether the candidate currently meets the employer visibility minimum. */
  workProfileVisible: boolean;
  /** Auth user id for analytics identity stitching; absent for anonymous. */
  userId?: string;
};

export const ANON_NAV_STATE: NavState = {
  role: null,
  unreadCount: 0,
  shortlistCount: 0,
  crewAnyUnread: false,
  crewAnyMention: false,
  hasEpicSpot: false,
  callsUnread: false,
  workProfileVisible: false,
};
